import { useEffect } from 'react';

const useTitle = (title = '', suffix = true) => {
  useEffect(() => {
    const defaultTitle = 'PIH';
    const suffixTxt = 'PIH';

    if(title) {
      document.title = `${title}${suffix ? (' / ' + suffixTxt) : ''}`;
    } else {
      // Default if empty
      document.title = defaultTitle;
    }

    // Without this the previous title would stay even when navigating to another page that does not set title.
    return () => document.title = defaultTitle;
  }, [title]);
};

export default useTitle;
